import { Pipe, PipeTransform } from '@angular/core';
import moment from "moment";
import { WfdssCaseSearchDTO } from 'src/app/_types/wfdss-case-search-dto';
@Pipe({
    name: 'protectingUnit',
    standalone: false
})
export class CaseSearchProtectingUnitPipe implements PipeTransform {

  transform(wfCase: WfdssCaseSearchDTO): string {
    let unitString = ""
    if(wfCase?.protectingUnitAtPoO?.unitIrwinId){
       unitString = unitString.concat(wfCase.protectingUnitAtPoO.unitIrwinId)
    }
    if(wfCase?.protectingUnitAtPoO?.name){
        unitString = unitString.concat(" - ", wfCase.protectingUnitAtPoO.name)
    }
    return unitString
  }

} 
